import interactEditorButtonTemplate from './interact-editor-button.tpl.html';
import './interact-editor-button.less';
import { isString } from '../../utils/type-utils';
import { ucFirst } from '../../utils/string-utils';

export const interactEditorButtonComponentModule = angular
  .module('Q.components.interact-editor-button', [])

  .component('interactEditorButton', {
    bindings: {
      interact: '<interactService',
      ngDisabled: '<',
      expired: '<',
    },
    controller: 'InteractEditorButtonCtrl',
    template: interactEditorButtonTemplate,
  })

  .controller('InteractEditorButtonCtrl', function InteractEditorButtonCtrl() {
    const ctrl = this;

    ctrl.btnStyle = () => {
      return ctrl.interact && !ctrl.expired && ctrl.interact.cannotEdit
        ? 'info'
        : 'default';
    };

    ctrl.privateEditing = () => {
      return (
        ctrl.interact &&
        ctrl.interact.privateEditing &&
        ctrl.interact.hasOtherEditor
      );
    };

    ctrl.disabled = () => {
      return (
        ctrl.expired ||
        ctrl.ngDisabled ||
        !ctrl.interact ||
        ctrl.interact.isConnecting
      );
    };

    ctrl.buttonClasses = () => {
      let base = (ctrl.interact && ctrl.interact.buttonClasses()) || '';
      if (ctrl.expired) {
        base += ' challenge-expired';
      }
      return base;
    };

    ctrl.editorLabel = () => {
      const interact = ctrl.interact;
      let label = 'Initializing…';
      if (interact) {
        if (ctrl.expired) {
          label = isString(ctrl.expired)
            ? ucFirst(ctrl.expired)
            : 'Time limit reached';
        } else if (interact.activeEditor) {
          label = interact.isUserActiveEditor
            ? 'You are editing'
            : interact.activeEditor.name;
        } else if (interact.isConnecting) {
          label = 'Connecting to Interact…';
        } else if (interact.isDisconnected) {
          label = 'Not Connected';
        } else {
          label = 'No Recent Editor';
        }
      }
      return label;
    };

    ctrl.onClick = () => {
      const interact = ctrl.interact;
      if (interact && !ctrl.disabled()) {
        if (interact.isDisconnected) {
          interact.reconnect();
        } else if (interact.isConnected) {
          // takes over editing
          interact.updateFile();
        }
      }
    };
  });
